export const environment = {
  production: true,
  runtimeEnvironment: {
    // for local development with `ng serve`
    VTR_API_URL: 'https://api.xn--80adja5bqm0f.xn--p1ai/',
//     VTR_GTM_ID: 'GTM-PMPP59K',  // it's a prod GTM
    VTR_GTM_ID: 'G-0QXRDT1673',
    VTR_DOMAIN: '.xn--80adja5bqm0f.xn--p1ai',
    VTR_YANDEX_VERIFICATION: '2d0f036b30ebdc60',
  },

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts